import { EventRequestCategory } from '@/constants/EventRequestCategory.enum';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

// Category-specific placeholder images
const movieBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterFilmLandscape.jpg');
const moviePosterPlaceholder = loadAsset('/images/placeholders/portrait/im-posterFilmPortrait.jpg');
const gamingEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterGamingLandscape.jpg');
const gamingEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-gamingEvent.png');
const presentationEventBackdropPlaceholder = loadAsset(
    '/images/placeholders/landscape/im-posterPresentationLandscape.jpg'
);
const presentationEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-presentationEvent.png');
const ideaEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterEventIdeaLandscape.jpg');
const ideaEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-ideaEvent.png');
const businessEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterBusinessLandscape.jpg');
const businessEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-businessEvent.png');

/**
 * Get category-specific placeholder image URL based on event request category and image type
 * @param category EventRequestCategory or string
 * @param type 'poster' or 'backdrop'
 * @returns Image URL string
 */
export function getCategorySpecificImage(category: EventRequestCategory | string, type: 'poster' | 'backdrop'): string {
    switch (category) {
        case EventRequestCategory.MOVIE_SERIES:
            return type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
        case EventRequestCategory.GAMING:
            return type === 'poster' ? gamingEventPosterPlaceholder : gamingEventBackdropPlaceholder;
        case EventRequestCategory.PRESENTATION:
            return type === 'poster' ? presentationEventPosterPlaceholder : presentationEventBackdropPlaceholder;
        case EventRequestCategory.OWN_CONTENT:
            return type === 'poster' ? ideaEventPosterPlaceholder : ideaEventBackdropPlaceholder;
        case EventRequestCategory.BUSINESS:
            return type === 'poster' ? businessEventPosterPlaceholder : businessEventBackdropPlaceholder;
        case EventRequestCategory.DISCOVER:
            return type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
        default:
            return type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
    }
}

// Export default placeholders for cases where no category is available
export const defaultMovieBackdropPlaceholder = movieBackdropPlaceholder;
export const defaultMoviePosterPlaceholder = moviePosterPlaceholder;
